import Icon from '../components/Icon.vue'

Icon.register({
  smile: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM362.8 346.2C334.3 380.4 292.5 400 248 400S161.7 380.4 133.2 346.2C119.6 329.9 144.2 309.5 157.8 325.7 180.2 352.6 213 367.9 248 367.9S315.8 352.5 338.2 325.7C351.6 309.5 376.3 329.9 362.8 346.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smile.js
// module id = sBzW
// module chunks = 144